import { Injectable } from '@angular/core';
import { ApiBaseService } from '@shared/services/entities/api-base.service';

/**
 * Corte de inventario de CEDIS (Macrocentro / FSL) que sale de SAP.
 *
 * SAP manda y la app es un espejo: aquí solo se consulta (`search`) y se
 * recarga por corte completo (`loadSnapshot`). No hay create/update fila a
 * fila a propósito — "el inventario de CEDIS no se edita, se recarga".
 */
@Injectable({ providedIn: 'root' })
export class StockSapService extends ApiBaseService<any> {
  constructor() {
    super('stocksap');
  }

  /**
   * Guarda un corte completo de SAP (todos los macrocentros, FSL y cuentas
   * en un solo archivo) y su documento de carga. Ya no va por ubicación.
   */
  public async loadSnapshot(payload: {
    /** CONSIGNA (Inventario SAP Consigna) o PLANTA (Inventario SAP Planta). */
    kind?: 'CONSIGNA' | 'PLANTA';
    snapshotDate?: string;
    fileName?: string;
    notes?: string;
    /** Renglones del Excel de SAP tal cual (columna → valor). */
    products: any[];
  }): Promise<Utils.ApiResponse<any>> {
    return this.request<any>('stocksap/load', 'POST', payload);
  }
}
